import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './PaymentSuccess.css';
import { getServiceById } from './servicesData';

const PaymentSuccess = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const serviceId = params.get('serviceId');
  const service = getServiceById(serviceId);

  // 获取预约信息
  const bookingInfo = useMemo(() => {
    const address = params.get('address');
    const date = params.get('date');
    const time = params.get('time');
    const phone = params.get('phone');
    const notes = params.get('notes');
    
    if (address && date && time && phone) {
      return {
        address,
        date,
        time,
        phone,
        notes: notes || ''
      };
    }
    return null;
  }, [params]);

  // 格式化日期时间显示
  const formatDateTime = (date, time) => {
    if (!date || !time) return '';
    
    const dateObj = new Date(`${date} ${time}`);
    const formatDate = dateObj.toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    });
    const formatTime = dateObj.toLocaleTimeString('zh-CN', {
      hour: '2-digit',
      minute: '2-digit'
    });
    
    return `${formatDate} ${formatTime}`;
  };

  return (
    <div className="pay-success-page">
      <header className="success-header">
        <h1>支付结果</h1>
      </header>

      <div className="container">
        <div className="success-card">
          <div className="icon">✅</div>
          <h2>支付成功</h2>
          {service ? (
            <p className="hint">
              您已成功预约 {service.name}
              {bookingInfo ? '，我们已收到您的预约信息' : ''}
              ，稍后将有客服与您联系确认详细信息。
            </p>
          ) : (
            <p className="hint">订单支付成功，稍后将有客服与您联系。</p>
          )}

          {/* 显示预约信息 */}
          {bookingInfo && (
            <div className="booking-summary">
              <h3>预约详情</h3>
              <div className="booking-details">
                <div className="booking-item">
                  <span className="label">服务地址：</span>
                  <span className="value">{bookingInfo.address}</span>
                </div>
                <div className="booking-item">
                  <span className="label">服务时间：</span>
                  <span className="value">{formatDateTime(bookingInfo.date, bookingInfo.time)}</span>
                </div>
                <div className="booking-item">
                  <span className="label">联系电话：</span>
                  <span className="value">{bookingInfo.phone}</span>
                </div>
                {bookingInfo.notes && (
                  <div className="booking-item">
                    <span className="label">注意事项：</span>
                    <span className="value">{bookingInfo.notes}</span>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="actions">
            <Link to="/" className="btn btn-secondary">返回首页</Link>
            <Link to="/profile" className="btn">前往个人中心</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;

